export interface IHealthcareFacilityInfo {
    id: number;
    name: string;
}

export interface ICurrentUser {
    patientID: string;
    healthcareProfessionalID: string;
    redirect: string;
    displayName: string;
    language: string;
    hasProfile: boolean;
    termsAccepted: boolean;
    termsAcceptedVersion?: string;
    termsAcceptedDate?: string;
    healthcareFacilities?: IHealthcareFacilityInfo[];
    selectedHealthcareFacilityID?: number;
    showAuditLogViewer?: boolean;
}

export class CurrentUser {
    public patientID: string;
    public healthcareProfessionalID: string;
    public redirect: string;
    public displayName: string;
    public language: string;
    public hasProfile: boolean;
    public termsAccepted: boolean;
    public termsAcceptedVersion?: string;
    public termsAcceptedDate?: string;
    public healthcareFacilities?: IHealthcareFacilityInfo[];
    public selectedHealthcareFacilityID?: number;
    public showAuditLogViewer?: boolean;

    constructor(input: ICurrentUser) {
        this.patientID = input.patientID;
        this.healthcareProfessionalID = input.healthcareProfessionalID;
        this.redirect = input.redirect;
        this.displayName = input.displayName;
        this.language = input.language;
        this.hasProfile = input.hasProfile;
        this.termsAccepted = input.termsAccepted;
        this.termsAcceptedVersion = input.termsAcceptedVersion;
        this.termsAcceptedDate = input.termsAcceptedDate;
        this.healthcareFacilities = input.healthcareFacilities;
        this.selectedHealthcareFacilityID = input.selectedHealthcareFacilityID;
        this.showAuditLogViewer = input.showAuditLogViewer;
    }
}
